
import React, { useState } from 'react';
import { Box, Typography,Container } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import bg_modal from '../Assets/texture.jpg'
import axios from 'axios';

const style = {
  
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor:'#fdeaac'
  
};

function ModalMail({openMail,closeMail}) {

  const[name,setName] = useState('');
  const[email,setEmail] = useState('');
  const[phone,setPhone] = useState('');
  const[country,setCounrty] = useState('');
  const[message,setMessage] = useState('');


function sendEmail(){
  
  axios.post('https://new-express-project-a2b1pj1tg-klim1812s-projects.vercel.app/', {
   
    name,
    email,
    // phone,
    // country,
    message
   
  }).then(() => alert('Message Send')).catch(() => console.log('Ooops no send message'));
 
 
};


const handleClose = () => {closeMail(false);setEmail('');setMessage('');setName('');setPhone('')};

const matches = useMediaQuery('(min-width:1000px)');


    return (
        <>
        
        
        <Modal
        open={openMail}
        onClose={handleClose}>
        
        <Container  sx={{...style,maxWidth:'700px',borderRadius:'20px'}}>
      {/* <img src={bg_modal}/> */}
        <Box sx={{textAlign:'center',margin:'20px',maxWidth:'40vw',marginLeft:'auto',marginRight:'auto'}}>
          <Typography variant='h6' fontFamily='Special Elite Regular' >Заполните форму и нажмите отправить, либо просто воспользуйтесь своей почтой, мой email: rahmaninov_andy@outlook.com</Typography></Box>
<Box sx={{marginLeft:'auto',marginRight:'auto'}}>
  <Box>{name}</Box>
  <Box>{email}</Box>
  <Box>{message}</Box>
        <TextField label="Имя,Фамилия *" variant="filled" color="primary" focused fullWidth  onChange={(e) =>setName(e.target.value)} sx={{marginTop:'20px'}}/>
        <TextField label="Введите Email *" variant="filled" color="primary" focused fullWidth onChange={(e) =>setEmail(e.target.value)}  sx={{marginTop:'20px'}}/>
        <TextField label="Номер телефона *" variant="filled" color="primary" focused fullWidth onChange={(e) =>setPhone(e.target.value)}  sx={{marginTop:'20px'}}/>
        <TextField label="Страна" variant="filled" color="primary" focused fullWidth onChange={(e) =>setCounrty(e.target.value)}  sx={{marginTop:'20px'}}/>
        <TextField label="Текст сообщения" variant="filled" color="primary" focused fullWidth onChange={(e) =>setMessage(e.target.value)}  sx={{marginTop:'20px'}}/>
        <Button variant="outlined" sx={{margin:4}} onClick={() => {sendEmail();handleClose()}} >Отправить</Button>
        </Box>
        
    {/* </Box> */}
   
   
      </Container>
      </Modal>
        
       
        </>
    );
  }
  
  export default ModalMail;